import {
    getCasePatientList,
    getDocPatientProfile, getMedicalOrderId, listForClinicPatient,
    updateDocPatientProfile
} from "@/api";
import {message, chackAlertMsg, alertMsg, addDateRange} from "@/assets/utils/common";
import baseConfig from "@/api/config";
import {uploadUrl} from "@/api/http";
import Orderdetail from "@/components/orderdetail.vue";
import {download} from "@/api/request";

export default {
    components: {Orderdetail},
    data() {
        return {
            currentPage: 1,
            pageNums: 15,
            totalCount: 0,
            queryParams: {
                name: '',
                identity: '',
                phoneNumber: '',
                doctorName: ''
            },
            orderId: null,
            searchParams: null,
            tableLoading: false,
            tableData: [],
            visitTime: [],
            dateOrderTime: '',
            tableHeight: 500,
            tencentCosUrl: baseConfig.tencentCosUrl,

            // 病历列表
            currentPageRecord: 1,
            pageNumsRecord: 20,
            totalCountRecord: 0,
            recordTableLoading: false,
            recordlist: [],
            recordTableHeight: 500,
            queryRecordParams: {
                chiefComplaint: null,
                dppId: null,
                docId: null
            },
            patientInfo: {
                docId: null, // 关联医生ID
                patientId: null, // 关联患者ID
                idcard: null,
                avatarImg: null,
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null, // 联系地址
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null,
                occupation: null, // 职业
                bloodType: null, // 血型
                marryStatus: null, // 婚姻状态
                patientType: null, // 患者类型
                allergyHistory: null, // 过敏史
                firstVisitResult: null, // 初诊意见
            },
            medicalRecord: {
                recordId: null, // 病历ID
                visitTime: null, // 就诊日期
                chiefComplaint: null, // 主诉
                presentIllness: null, // 现病史
                pastMedicalHistory: null, // 既往史
                personalHistory: null, // 个人史
                diagnosis: null, // 诊断
                morbidityDate: null, // 发病日期
                isFirstVisit: null, // 是否初诊
                treatmentEffect: null, // 治疗效果
                isInfectiousDiseases: null, // 是否传染病
                dealSuggestion: null, // 处理意见
                otherInstructions: null, // 其他说明
                temperature: null, // 体温
                bloodPressure: null, // 血压
                heartRate: null, // 心率
                breathing: null, // 呼吸
                physicalExamination: null, // 体格检查
            },
            patientInfoFrom:{
                name: null,
                sex: null,
                age: null,
                phoneNumber: null,
                identity: null,
                province: null,
                dppId: null,
                height: null,
                weight: null,
                casePic: null,
                operationHistory: null,
                medicalHistory: null
            },
            casePic: null,
            casePicArray: [],
            newUploadCasePicArray: [], // 最新需要上传的图片列表
            orderlist: [],
            patientId: null,
            direction: 'rtl',
            dppId: null,
            orderDetailDialogVisible: false,
            paetientDialogVisible: false,
            editBaseInfoVisible: false,
            uploadFileURL: uploadUrl,
            uploadHeaders: {
                Authorization: 'Bearer ' + window.sessionStorage.getItem('xtoken')
            },
            dialogImageUrl: '',
            dialogVisible: false,
            confileLists: [],
        }
    },
    mounted() {
        //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
        setTimeout(() => {
            this.tableHeight = window.innerHeight - this.$refs.multipleTable.$el.offsetTop - 80;
        },100)
        this.doctorInfo = JSON.parse(window.sessionStorage.getItem("doctorInfo"));
        if (this.doctorInfo !== null && this.doctorInfo !== undefined && this.doctorInfo !== "") {
            this.patientInfo.docId = this.doctorInfo.doctorId;
        }
    },
    created() {
        this.getPatientListInfo();
    },
    methods: {
        handleExportCase(row){
            const caseIds = row.caseId || this.ids;
            download('buz/case/expClinicCase/'+caseIds,{},`clinicCase_`+caseIds+`.pdf`)
        },

        // chooseDateTime
        chooseDateTime() {
            addDateRange(this.queryParams, this.visitTime, "VisitTime");
        },

        changeData(name) {
            this.$router.push({path: '/admin/' + name});
            this.$store.state.adminleftnavnum = name; //设置左侧导航2-2 active
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.queryParams.name = "";
            this.queryParams.identity = "";
            this.queryParams.phoneNumber = "";
            this.getPatientListInfo();
        },


        // 切换分页
        handleCurrentChange: function(val) {
            this.currentPage = val;
            this.getPatientListInfo();
        },

        // 切换分页
        handleSizeChange: function(val) {
            this.pageNums = val;
            this.getPatientListInfo();
        },


        // 查询患者列表
        getPatientListInfo: function () {
            this.tableData = [];
            this.tableLoading = true;
            this.queryParams.pageNum = this.currentPage;
            this.queryParams.pageSize = this.pageNums;
            getCasePatientList(this.queryParams).then(res => {
                const rdata = res.data;
                console.log(rdata);
                this.tableLoading = false;
                if (rdata.code === 200) {
                    this.tableData = rdata.rows;
                    this.totalCount = rdata.total;

                    this.tableData.forEach((item) => {
                        if (item.patientSex === '男') {
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else if (item.patientSex === '女'){
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else {
                            item.patientSex = '未知';
                            item.avatar = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    })
                }
            }).catch(error => {
                message(error, "error");
            });
        },


        // 查看详情
        openPatientDetail(dppId) {
            this.dppId = dppId;
            this.paetientDialogVisible = !this.paetientDialogVisible;
            this.qryDetailInfo();// 查询详情
            //此处需要通过延迟方法来设置值，不然会出现值已更新，但页面没更新的问题
            setTimeout(()=>{
                if(this.$refs.multipleOrderTable){
                    this.$nextTick(() =>{
                        // 根据浏览器高度设置初始高度
                        this.recordTableHeight = window.innerHeight - this.$refs.multipleOrderTable.$el.offsetTop - 90
                        // 监听浏览器高度变化，修改表格高度
                        window.onresize = () =>{
                            this.recordTableHeight = window.innerHeight - this.$refs.multipleOrderTable.$el.offsetTop - 90
                        }
                    })
                }
            }, 100)
        },


        // 查询详情
        qryDetailInfo() {
            let data = {};
            getDocPatientProfile(this.dppId, data).then(response => {
                console.log(response);
                if (response.data.code === 200) {
                    if (response.data.data !== null && response.data.data !== undefined) {
                        this.patientInfo = response.data.data;
                        if (this.patientInfo.identity !== null && this.patientInfo.identity !== "" && this.patientInfo.identity !== undefined) {
                            let identityVal = this.patientInfo.identity;
                            this.patientInfo.identityVal = identityVal;
                            identityVal = identityVal.substr(0, 5) + "**********" + identityVal.substr(14, identityVal.length);
                            this.patientInfo.identity = identityVal;
                        }
                        this.casePic = this.patientInfo.casePic;
                        if (this.casePic !== null && this.casePic !== "" && this.casePic !== undefined) {
                            let casePicArr = this.casePic.split(",");
                            // console.log(casePicArr)
                            if (casePicArr.length > 0) {
                                this.casePicArray = [];
                                this.confileLists = [];
                                for (let i = 0; i < casePicArr.length; i++) {
                                    let casePicUrl = this.tencentCosUrl+casePicArr[i];
                                    // console.log("casePicUrl:"+casePicUrl)
                                    this.casePicArray.push(casePicUrl);
                                    var imageUrl = {"url": casePicUrl};
                                    this.confileLists.push(imageUrl);
                                }

                            } else {
                                this.casePicArray = [];
                                this.confileLists = [];
                            }
                        } else {
                            this.casePicArray = [];
                            this.confileLists = [];
                        }
                        // console.log("this.patientInfo.sex")
                        // console.log(this.patientInfo.sex)
                        if (this.patientInfo.sex === "1") {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/womanImg.png";
                        } else if (this.patientInfo.sex === "0"){
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/manImg.png";
                        } else {
                            this.patientInfo.avatarImg = this.tencentCosUrl + "/tcmmsPic/profile.jpg";
                        }
                    } else {
                        this.casePicArray = [];
                        this.confileLists = [];
                    }

                    this.recordlist = [];
                    this.getMedicalRecordList();
                }
            })
        },



        // 切换分页
        handleRecordCurrentChange: function (val) {
            this.currentPageRecord = val;
            this.getMedicalRecordList();
        },

        // 切换分页
        handleRecordSizeChange: function (val) {
            this.pageNumsRecord = val;
            this.getMedicalRecordList();
        },

        // 查询病历列表
        getMedicalRecordList() {
            this.recordTableLoading = true;
            //根据工单类型筛选，已完成订单
            this.queryRecordParams.dppId = this.dppId;
            this.queryRecordParams.docId = this.patientInfo.docId;
            this.queryRecordParams.pageNum = this.currentPageRecord;
            this.queryRecordParams.pageSize = this.pageNumsRecord;
            listForClinicPatient(this.queryRecordParams).then(response => {
                console.log("listMedicalRecord >>> " + response);
                this.recordTableLoading = false;
                if (response.data.code === 200) {
                    this.totalCountRecord = response.data.total;
                    this.recordlist = response.data.rows;
                }
            });
        },



        // 查询病历关联得订单详情
        openOrderDetail(recordId) {
            getMedicalOrderId(recordId).then(response => {
                console.log("getMedicalOrderId response");
                console.log(response);
                if (response.data.code === 200) {
                    this.orderId = response.data.data.data;
                    console.log(this.orderId);
                    this.orderDetailDialogVisible = true;
                } else {
                    alertMsg("未查询到对应订单ID！", "error");
                }
            });
        },

        // 关闭订单详情
        closeOrderDetail() {
            this.orderDetailDialogVisible = false;
        },


        // 回显病历信息
        setMedicinalRecord(row) {
            console.log(row);
            this.medicalRecord = row;
            this.medicalRecord.recordId = "";
            let sessionData= {
                "patientInfo": this.patientInfo,
                "medicalRecord": this.medicalRecord
            }
            window.sessionStorage.removeItem("patient_"+this.patientInfo.dppId);
            window.sessionStorage.setItem("patient_"+this.patientInfo.dppId, JSON.stringify(sessionData));
            window.sessionStorage.setItem("patientDppId", this.patientInfo.dppId);

            this.$router.push({path: '/admin/clinictreat'});
            this.$store.state.adminleftnavnum = 'clinictreat'; //设置左侧导航2-2 active
        },




        beforeAvatarUpload(file) {
            const isJPG = file.type === 'image/jpeg'
            const isLt2M = file.size / 1024 / 1024 < 2
            if (!isJPG) {
                this.$message.error('上传头像图片只能是 JPG 格式!')
            }
            if (!isLt2M) {
                this.$message.error('上传头像图片大小不能超过 2MB!')
            }
            return isJPG && isLt2M
        },
        // 移除选择的图片
        handleRemove(file) {
            // console.log("移除图片");
            for (let j = 0; j < this.casePicArray.length; j++) {
                if(this.casePicArray[j] === file.url) {
                    this.casePicArray.splice(j, 1);
                }
            }
            // console.log(this.casePicArray);

            for (let i = 0; i < this.newUploadCasePicArray.length; i++) {
                if(this.newUploadCasePicArray[i] === file.url) {
                    this.newUploadCasePicArray.splice(i, 1);
                }
            }
            // console.log("this.newUploadCasePicArray");
            // console.log(this.newUploadCasePicArray);

            const deleteImgPath = file.url.replace(this.tencentCosUrl, "");
            // console.log("deleteImgPath >>>>> " + deleteImgPath);
            // console.log(this.casePic);
            if (this.casePic !== null && this.casePic !== "" && this.casePic !== undefined) {
                let casePicArr = this.casePic.split(",");
                // console.log("befor deleteImg")
                // console.log(casePicArr)
                for (let s = 0; s < casePicArr.length; s++) {
                    if(casePicArr[s] === deleteImgPath) {
                        casePicArr.splice(s, 1);
                    }
                }
                // console.log("after deleteImg")
                // console.log(casePicArr)

                this.casePic = casePicArr.join(",");
                // console.log("000 >>> " + this.casePic);
            }
        },
        handlePictureCardPreview(file) {
            this.dialogImageUrl = file.url
            this.dialogVisible = true
        },
        handleAvatarSuccess(res) {
            if (res.code === 200) {
                this.newUploadCasePicArray.push(res.fileName);
            }
        },

        // 修改患者基本信息
        editBaseInfo() {
            this.editBaseInfoVisible = !this.editBaseInfoVisible;
            this.patientInfoFrom.patientId = this.patientInfo.patientId;
            this.patientInfoFrom.dppId = this.patientInfo.dppId;
            this.patientInfoFrom.name = this.patientInfo.name;
            this.patientInfoFrom.sex = this.patientInfo.sex;
            this.patientInfoFrom.age = this.patientInfo.age;
            this.patientInfoFrom.height = parseInt(this.patientInfo.height);
            this.patientInfoFrom.weight = parseInt(this.patientInfo.weight);
            this.patientInfoFrom.phoneNumber = this.patientInfo.phoneNumber;
            this.patientInfoFrom.identity = this.patientInfo.identityVal;
            this.patientInfoFrom.province = this.patientInfo.province;
            this.patientInfoFrom.operationHistory = this.patientInfo.operationHistory;
            this.patientInfoFrom.medicalHistory = this.patientInfo.medicalHistory;
            this.patientInfoFrom.casePic = this.patientInfo.casePic;
            this.newUploadCasePicArray = [];
        },

        // 取消编辑患者基本信息
        cancelEditBaseInfo() {
            this.editBaseInfoVisible = false;
        },


        // 保存患者基本信息
        saveEditBaseInfo() {
            if (this.newUploadCasePicArray.length > 0) {
                this.patientInfoFrom.casePic = this.newUploadCasePicArray.join(',');
            } else {
                this.patientInfoFrom.casePic = this.patientInfo.casePic;
            }
            const name = this.patientInfoFrom.name;
            const sex = this.patientInfoFrom.sex;
            const age = this.patientInfoFrom.age;
            const phoneNumber = this.patientInfoFrom.phoneNumber;
            if (chackAlertMsg(name, '患者姓名不能为空', 'error')
                && chackAlertMsg(sex, '患者性别不能为空', 'error')
                && chackAlertMsg(age, '患者年龄不能为空', 'error')
                && chackAlertMsg(phoneNumber, '联系电话不能为空', 'error'))
            {
                updateDocPatientProfile(this.patientInfoFrom).then(res => {
                    if (res.code === 200) {
                        this.editBaseInfoVisible = false;
                        this.qryDetailInfo();// 查询详情
                    }
                }).catch(error => {
                    message(error, "error");
                });
            }
        },


    }
}
